import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onMount } from "svelte";
import { initMap } from "@/map";
import { mapStore } from "@/stores/map.svelte";

var root = $.from_html(`<div class="map-wrap svelte-3h6stvsizl8ne"><div class="map-container svelte-3h6stvsizl8ne"></div> <button class="fullscreen-btn svelte-3h6stvsizl8ne" title="Fullscreen">⛶</button></div>`);

function Map($$anchor, $$props) {
	$.push($$props, true);

	let container;

	onMount(() => {
		const map = initMap(container);

		return () => map.remove();
	});

	$.user_effect(() => {
		if (!container) return;

		const el = container.querySelector(".leaflet-control-mouseposition");

		if (el) el.style.display = mapStore.showCoords ? "" : "none";
	});

	var div = root();
	var div_1 = $.child(div);

	$.bind_this(div_1, ($$value) => container = $$value, () => container);

	var button = $.sibling(div_1, 2);

	$.reset(div);
	$.delegated('click', button, () => mapStore.toggleFullscreen());
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	Map = $.hmr(Map);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3h6stvsizl8ne');
		Map[$.HMR].update(module.default);
	});
}

export default Map;

$.delegate(['click']);
import "bun-svelte:Map.svelte-2wwihnyo2l2mk-style.css";